var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    opacity: 0.1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12v8h4v-8z",
    fill: "#5491c7"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M6 12 V20 H10 V12z; M6 4 V28 H10 V4z; M6 12 V20 H10 V12z; M6 12 V20 H10 V12z",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0,
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
    calcMode: "spline"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12v8h4v-8z",
    fill: "#316faa"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M11 12 V20 H15 V12z; M11 4 V28 H15 V4z; M11 12 V20 H15 V12z; M11 12 V20 H15 V12z",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0.2,
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
    calcMode: "spline"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12v8h4v-8z",
    fill: "#205e99"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M16 12 V20 H20 V12z; M16 4 V28 H20 V4z; M16 12 V20 H20 V12z; M16 12 V20 H20 V12z",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0.4,
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
    calcMode: "spline"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12v8h4v-8z",
    fill: "#02488b"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M21 12 V20 H25 V12z; M21 4 V28 H25 V4z; M21 12 V20 H25 V12z; M21 12 V20 H25 V12z",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0.6,
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.8 0.4 0.8",
    calcMode: "spline"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBars);
export default __webpack_public_path__ + "static/media/loading-bars.090040d9af0012936e9467faad4dd2d4.svg";
export { ForwardRef as ReactComponent };